"use client";

import { AUEData, useAUEData } from "@/hooks/useAUEData";
import React, { createContext, useContext, type ReactNode } from "react";

const AUEContext = createContext<AUEData | undefined>(undefined);

export function useAUE() {
  const ctx = useContext(AUEContext);
  if (!ctx) throw new Error("useAUE must be used within an AUEProvider");
  return ctx;
}

export function AUEProvider({ children }: { children: ReactNode }) {
  const value = useAUEData();

  return <AUEContext.Provider value={value}>{children}</AUEContext.Provider>;
}